/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlHealthWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ControlHealthWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ControlHealthWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ControlHealthWidgetConfiguration>): ControlHealthWidgetConfiguration {
        let obj = Object.assign(new ControlHealthWidgetConfiguration(), model);
        ControlHealthWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlHealthWidgetConfiguration>): ControlHealthWidgetConfiguration {
        if (!model) return null;
        return ControlHealthWidgetConfiguration.newInstance(<ControlHealthWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlHealthWidgetConfiguration) {
        if (!obj) return;

        models.ControlHealthWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlHealthWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ControlHealthWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
